import { formatMoney } from 'utils/storefront/format-resource';
import { decodeId } from './helpers';

export function trackEvent(param) {
  window.dataLayer.push(param);
}

// Track add to cart event copied over from pre-existing live site THINX
export async function trackAddToCart({ product, variant, quantity = 1 }) {
  const eventID = `${Date.now().toString()}-${Math.random()}`;
  const eventData = {
    event: 'addtocart',
    // Event ID used by facebook to connect server and client events
    event_id: eventID,

    // variant data of added item
    variant_price: formatMoney(variant.price),
    variant_sku: variant.sku,
    variant_title: variant.title,
    variant_id: decodeId(variant.id, 'ProductVariant'),
    product_id: String(product.id).includes('gid') ? decodeId(product.id, 'Product') : product.id,

    // additional product info
    brand: product.vendor,
    quantity,
    currency: variant.price?.currencyCode || 'USD',

    // TODO: legacy support. refactor in GTM
    u1: product.productType,
    u2: product.title,
    u3: variant.sku,
    u4: formatMoney(variant.price),
  };

  if (variant?.compareAtPrice?.amount > 0) {
    eventData.variant_sale_price = formatMoney(variant.compareAtPrice);
  }

  trackEvent(eventData);
}
